import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import 'rxjs/add/operator/map';
import { ApiResponse } from '../admin/apiresponse';
import { DeviceType } from '../admin/devicetype/devicetype';
import { AdalHttp } from './adal.http.service';
import { EventHttpService } from './event.http.service';
import { AuthHttp } from "./adal-async-http.service";

@Injectable()
export class DeviceTypeService {

    private actionUrl: string;
    private versionSelectionModeActionUrl: string;
    private testGroupFilterModeActionUrl: string;
    private downloadUrlExpirationActionUrl: string;
    private headers: Headers;
    private apiResponse: ApiResponse;

    constructor(private _http: AdalHttp, private _configuration: Configuration, private _httpAuth: AuthHttp) {

        this.actionUrl = _configuration.ServerWithApiUrl + 'devicetype/';
        this.versionSelectionModeActionUrl = _configuration.ServerWithApiUrl + 'versionselectionmode/';
        this.testGroupFilterModeActionUrl = _configuration.ServerWithApiUrl + 'testgroupfiltermode/';
        this.downloadUrlExpirationActionUrl = _configuration.ServerWithApiUrl + 'downloadurlexpiration/';

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
    }

    public createDeviceType = (deviceType): Observable<any> => {
        let body = JSON.stringify(deviceType);
        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, body, options);
    }

    public updateDeviceType = (deviceType): Observable<any> => {
        let body = JSON.stringify(deviceType);
        let options = new RequestOptions({ headers: this.headers });
        return this._http.put(this.actionUrl, body, options);
    }

    public getDeviceTypes(): Observable<any> {
        return this._http.get(this.actionUrl);
    }

    public getDeviceType(deviceType: string): Observable<any> {
        return this._http.get(this.actionUrl + "/" + deviceType);
    }

    public getDeviceTypesAsync(): Promise<any> {
        return this._httpAuth.getAsync(this.actionUrl);
    }

    public deleteDeviceType(name: string): Observable<any> {
        return this._http.delete(this.actionUrl + '/' + name);
    }

    public getTestGroupFilterModes(): Observable<any> {
        return this._http.get(this.testGroupFilterModeActionUrl);
    }

    public getVersionSelectionModes(): Observable<any> {
        return this._http.get(this.versionSelectionModeActionUrl);
    }

    public getUrlExpirationValues(): Observable<any> {
        return this._http.get(this.downloadUrlExpirationActionUrl);
    }
}


// WEBPACK FOOTER //
// ./app/services/devicetype.service.ts